<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div v-if="loading">
      <loading />
    </div>

    <div class="mt-15 ml-15 mr-15">
      <v-card class="mt-5">
        <v-card-title class="primary--text">Familieoverleg </v-card-title>
        <tablea-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportA />

          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">Toekomstvisie </v-card-title>
        <tableb-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportB />

          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">Eigendom en Financiën </v-card-title>
        <tablec-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportC />

          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">Opvolging </v-card-title>
        <tabled-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportD />

          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">Beloning</v-card-title>
        <tablee-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportE />

          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">Social Media </v-card-title>
        <tablef-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportF />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import TableaStatus from "@/components/Lchart/TableaStatus";
import TablebStatus from "@/components/Lchart/TablebStatus";
import TablecStatus from "@/components/Lchart/TablecStatus";
import TabledStatus from "@/components/Lchart/TabledStatus";
import TableeStatus from "@/components/Lchart/TableeStatus";
import TablefStatus from "@/components/Lchart/TablefStatus";

import ReportA from "@/components/Lchart/Reports/NL/ReportA";
import ReportB from "@/components/Lchart/Reports/NL/ReportB";
import ReportC from "@/components/Lchart/Reports/NL/ReportC";
import ReportD from "@/components/Lchart/Reports/NL/ReportD";
import ReportE from "@/components/Lchart/Reports/NL/ReportE";
import ReportF from "@/components/Lchart/Reports/NL/ReportF";

import LchartService from "@/services/lchart/LchartService";
import Loading from "@/components/loading";

export default {
  name: "lchartview",
  components: {
    Loading,
    ToolbarAuth,
    Navigation,
    TableaStatus,
    TablebStatus,
    TablecStatus,
    TabledStatus,
    TableeStatus,
    TablefStatus,

    ReportA,
    ReportB,
    ReportC,
    ReportD,
    ReportE,
    ReportF,
  },
  data() {
    return {
      loading: false,
      dataext: {},
    };
  },
  methods: {
    getData() {
      let id = this.$route.params.famId;
      this.loading = true;
      LchartService.getMain(id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },

    closeView() {
      this.$router.replace({
        name: "lchartIndex",
      });
    },
  },
  computed: {
    // ...mapGetters("fchartresult", ["astoremodules"]),
    // ...mapGetters("fchartBresult", ["bstoremodules"]),
    ...mapGetters("colors", ["colors"]),
  },

  created() {
    let id = this.$route.params.famId;
    this.$store.dispatch("lchartAresult/getAmodule", id);
    this.$store.dispatch("lchartBresult/getAmodule", id);
    this.$store.dispatch("lchartCresult/getAmodule", id);
    this.$store.dispatch("lchartDresult/getAmodule", id);
    this.$store.dispatch("lchartEresult/getAmodule", id);
    this.$store.dispatch("lchartFresult/getAmodule", id);

    let colorId = 1;
    this.$store.dispatch("colors/getMains", colorId);
    this.getData();
  },
};
</script>

<style scoped></style>
